import { signDocument, SUPPORTED_SIGNING_ALGORITHM } from '@tradetrust-tt/tradetrust';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
async function signOA(document, keyPair) {
  return signDocument(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document,
    SUPPORTED_SIGNING_ALGORITHM.Secp256k1VerificationKey2018,
    keyPair
  );
}
__name(signOA, "signOA");

export { signOA };
